import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { createCustomSurfaceTreatmentApi } from "#modules/companySettings/infra/createCustomSurfaceTreatment.api";
import { customSurfaceTreatmentsQuery } from "#modules/companySettings/infra/customSurfaceTreatments.query";
import { processStepCatalogQuery } from "#modules/quoteRequestLines/infra/processStepCatalogQuery";

export const useCreateCustomSurfaceTreatment = () => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: createCustomSurfaceTreatmentApi,
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries(customSurfaceTreatmentsQuery(variables.companyId));
      void queryClient.invalidateQueries(processStepCatalogQuery());
    },
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);
    },
  });

  return { createCustomSurfaceTreatment: mutate, ...rest };
};
